export default __webpack_public_path__ + "static/media/1264.8a9ec2a3.png";